// extracted by mini-css-extract-plugin
export default {"headerActions":"search_section-module__headerActions--3xIe6"};